<template>
  <div>
    <div v-if="!loading" class="xml-detail d-flex align-item-center">
      <div class="mr-4">
        <a
          v-if="scopeXmlDetail"
          href="javascript:void(0)"
          id="collapse"
          @click="collapse"
          class="
            ag-button
            sm
            border-0
            ag-button_secondary ag-button_radius
            ml-2
          "
          >Collapse</a
        >
      </div>
      <div class="json-area">
        <JsonView
          :data="scopeXmlDetail"
          :max-depth="5"
          :open="open"
          :key="compKey"
        ></JsonView>
      </div>
      <div class="d-flex flex-row extra-info">
        <!-- <p class="mr-3">
          <span>Endpoint: </span> <strong> SRV2016-AGE</strong>
        </p> -->
        <p class="mr-3">
          <span>Alert Time: </span> <strong> {{ formatDate(alertDetail.createdAt) }}</strong>
        </p>
        <p>
          <a
            href="javascript:void(0)"
            class="name-btn download-btn"
            @click="download"
            id="download"
          >
            <i class="download-icon ag-icon ag-icon_download"></i>
            Download
          </a>
        </p>
      </div>
    </div>
    <AgLoading v-if="loading"></AgLoading>
  </div>
</template>
<script>
import * as xmljs from "xml-js";
import JsonView from "./components/JsonView";
import api from "@/store/axiosAgsc";
import { useStore } from "@/store";
import AgLoading from "@/components/ag-loading/index.vue";
import moment from "moment";

const store = useStore();
export default {
  name: "ag-xml-detail",
  components: { JsonView, AgLoading },
  data() {
    return {
      open: false,
      loading: true,
      scopeXmlDetail: null,
      alertDetail: null,
      compKey: 0
    };
  },
  created() {
    this.getList();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      this.getList();
    },
  },
  methods: {
    getList() {
      const data = localStorage.getItem("scopeAlertDetailData");
      try {
        this.alertDetail = JSON.parse(data);
      } catch (error) {
        console.log(error);
      }
      if (!this.alertDetail) {
        return;
      }
      this.loading = true;
      api.get("Alarm/DownloadCorruptedFileObject?id=" + this.alertDetail.id).then((res) => {
        const xml = res.data.entityData.fileContentPlain;
        try {
          this.scopeXmlDetail = JSON.parse(
            xmljs.xml2json(xml, {
              compact: true,
              spaces: 4,
            })
          );
        } catch (err) {
          console.log(err);
        }
        setTimeout(() => {
          this.loading = false;
          ++this.compKey;
        }, 350);
      });
    },
    download() {
      var elem = document.querySelector("#download");
      if (elem) {
        var data =
          "text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(this.scopeXmlDetail));
        elem.setAttribute("href", "data:" + data);
        elem.setAttribute("download", "data.json");
      }
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY H:m A')
    },
    collapse() {
      this.open = !this.open;
      ++this.compKey;
    },
  },
};
</script>

<style lang="scss" scoped>
.xml-detail {
  #collapse {
    margin-left: 0 !important;
    margin-bottom: 1.5rem;
    padding: 5px 10px;
    display: inline-block;
  }

  .json-area {
    max-width: 80%;
    width: 50%;
  }

  .ag-scopeXmldetail {
    height: 60vh;
    overflow: auto;
  }

  .extra-info {
    margin-top: -48px;
    margin-left: auto;
    .download-btn {
      color: #4c8dbb;
      i {
        font-size: 10px;
      }
    }
  }

  span {
    color: #8e8e8e;
  }

  strong {
    color: #8e8e8e;
  }
}
</style>
